module.exports = __webpack_public_path__ + "media/images/top/common/img_feature03-4bdc21c694f206e1152af7b3a18d7d74.png";